// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const verticalBarChart = "VerticalBarChart__verticalBarChart__f5-dm";
export const verticalBarChartInner = "VerticalBarChart__verticalBarChartInner__POOXb";
export const allZero = "VerticalBarChart__allZero__kn3-+";
export const axis = "VerticalBarChart__axis__f7awY";
export const bar = "VerticalBarChart__bar__tnYea";
export const member = "VerticalBarChart__member__XTwro";
export const peers = "VerticalBarChart__peers__UlkgA";
export const others = "VerticalBarChart__others__31-9u";
export const negative = "VerticalBarChart__negative__z0lm1";
export const zeroValue = "VerticalBarChart__zeroValue__16ctD";
export const barValue = "VerticalBarChart__barValue__Hrx2x";
export const barLabel = "VerticalBarChart__barLabel__0E+66";